export const SignatureQcFieldName = 'signatureQcFieldComponent';
